<template>
  <div v-if="renderLogin" class="login column align-center justify-center">
    <div class="login-background" v-if="background"></div>
    <div class="login-box">
      <div class="login-box-container">
        <div class="align-center column">
          <img src="../assets/img/logo-client-icon.png" alt="NS SUPPORT" width="200" />
          <div class="font-15 instructions">
            Entre com seus dados para acessar sua conta:
          </div>
        </div>
        <div class="mask">
          <div class="mask-scroll row">
            <div class="mask-login" :class="recover ? 'recue' : ''">
              <form onsubmit="return false;" @submit="login()">
                <div class="font-12 column grid-12 field">
                  <label for="email">Seu e-mail</label>
                  <input
                    id="email"
                    v-model="dados.login"
                    type="text"
                    name="email"
                    placeholder="e-mail"
                    required
                  />
                </div>
                <div class="font-12 column grid-12 field">
                  <label for>Sua senha</label>
                  <div class="row">
                    <input
                      id="pass"
                      v-model="dados.senha"
                      placeholder="senha"
                      :type="isPwd ? 'password' : 'text'"
                      required
                    />
                    <i
                      class="see fa"
                      @click="isPwd = !isPwd"
                      :class="isPwd ? 'fa-eye' : 'fa-eye-slash'"
                    ></i>
                  </div>
                </div>
                <div class="row control grid-12 justify-space align-center">
                  <a class="forgot" href="#" @click="recover = true"
                    >Esqueci minha senha</a
                  >

                  <Button
                    id="submit"
                    layout="green-m"
                    :loader="loader"
                    type="submit"
                    :disabled="loader"
                    >FAZER LOGIN</Button
                  >
                </div>
              </form>
            </div>
            <div class="recover">
              <div class="font-12 column grid-12 field">
                <label for="email">Seu e-mail cadastrado em nosso portal</label>
                <input
                  v-model="dados.login"
                  type="text"
                  name="email"
                  placeholder="e-mail"
                  required
                />
              </div>
              <div class="row control grid-12 justify-space align-center">
                <Button layout="white-m-gray" type="button" @click="recover = false">
                  <i class="fa fa-arrow-left"></i> Voltar
                </Button>

                <Button
                  layout="green-m"
                  type="button"
                  :loader="loader"
                  @click="
                    loader = true;
                    FORGOT_PASS(dados.login)
                      .then(() => (loader = false))
                      .catch(() => (loader = false));
                  "
                  >RECUPERAR SENHA</Button
                >
              </div>
            </div>
          </div>
        </div>

        <div class="create grid-12">
          Não tem uma conta?
          <a :href="api.login.newAccount">
            <strong>Crie uma agora!</strong>
          </a>
        </div>
      </div>
    </div>
    <Status />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Api from "@/conf/Api";
import Button from "@/components/Button.vue";
import Status from "@/components/Status.vue";
import router from '@/router'
export default {
  name: "Login",
  components: {
    Button,
    Status,
  },
  data() {
    return {
      api: Api,
      isPwd: true,
      dados: {
        login: "",
        senha: "",
        origem: "web2"
      },
      loader: false,
      recover: false,
      background: true,
      renderLogin: localStorage.getItem("token") ? false : true,
    };
  },
  methods: {
    ...mapActions("user", ["SET_LOGIN", "FORGOT_PASS"]),
    login(data) {
      this.loader = true;
      this.SET_LOGIN(data || this.dados)
        .then(() => this.loader = false)
        .catch(() => this.loader = false);
    }
  },
  beforeMount() {
    if(this.user){
     if(this.user.perfil=='doutor') router.push("/supporter/dashboard")
     if(this.user.perfil=='funcionario') router.push("/funcionario/acompanhamento")
     if(this.user.perfil=='cliente') router.push("/cliente/dashboard")
    }
    // FIX INVALID TOKEN
    let token = localStorage.getItem("token");
    if (token && token.length < 100) {
      localStorage.clear();
      location.reload();
    }

    let url = window.location.toString();
    let cred = url.toString().split("?")[1];

    //LOGIN COM USUARIO E SENHA POR GET
    if (cred && url.indexOf("pass") > 0) {
      this.renderLogin = false;

      let login = "";
      let pass = "";
      cred
        .split("&")[0]
        .split("=")[1]
        .split("-")
        .filter((r) => (r ? (login += String.fromCharCode(r)) : ""));
      cred
        .split("&")[1]
        .split("=")[1]
        .split("-")
        .filter((r) => (r ? (pass += String.fromCharCode(r)) : ""));
      this.dados = {
        login: login,
        senha: pass,
        origem: "web2"
      };
      this.login();
    }

    //LOGIN WHITE LABEL
    if (
      cred &&
      url.indexOf("token=") > 0 &&
      url.indexOf("cliente=") > 0 &&
      (url.indexOf("email=") > 0 || url.indexOf("id_usuario=") > 0)
    ) {
      const token = cred.split("&")[1].split("=")[1];
      const client = cred.split("&")[2].split("=")[1];

      let payload =
        url.indexOf("email=") > 0
          ? {
              email: cred.split("&")[0].split("=")[1].replace("%40", "@"),
              token: token,
              client: client,
            }
          : {
              id: cred.split("&")[0].split("=")[1].replace("%40", "@"),
              token: token,
              client: client,
            };

      this.login(payload);
    }

    // LOGIN POR TOKEN APP
    if (cred && url.indexOf("token=") > 0 && url.indexOf("email=") == -1) {
      token = cred.split("=")[1];
      if (token.length > 100) {
        localStorage.setItem("token", token);
        this.renderLogin = false;
        this.login();
      }
    }

    this.background = window.innerWidth < 849 ? false : true;
  },
  computed: {
    ...mapGetters("general", ["status"]),
    ...mapGetters("user", ["user"]),
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.login {
  background-image: linear-gradient(to bottom, black, #111, black);
  height: 100vh;
  &-background {
    height: 100vh;
    position: absolute;
    width: 100%;
    z-index: -1;
  }

  &-box {
    overflow: hidden;
    /* width: 600px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 10px 15px #222; */
    @media (max-width: $small) {
      width: 100%;
      padding-top: 10%;
      height: 100vh;
    }
    @media (min-width: $small) {
      margin-top: -160px;
      border-radius: 21px;
    }

    &-container {
      padding: 40px 47px;
      padding-bottom: 23px;
    }

    .mask {
      width: 100%;
      overflow: hidden;

      &-scroll {
        width: 200%;
      }
      &-login {
        width: 60%;
        float: left;
      }
      .recue {
        margin-left: -70%;
      }

      .recover {
        margin-left: 10%;
        width: 49%;
      }
    }
  }
  .instructions {
    margin-top: 30px;
    margin-bottom: 27px;
    color: $client-1;
  }

  input {
    background: #fff;
    border: 1px solid $white-6;
    border-radius: 5px;
    opacity: 1;
    height: 47px;
    width: 90%;
    padding: 0px 5%;
    margin-top: 7px;
    color: $gray-2;

    &:focus {
      border-bottom: 5px solid $supporter-1;
    }
  }

  .field {
    margin-top: 19px;
    color: $supporter-1;
  }
  .see {
    font-size: 26px;
    position: relative;
    color: $gray-2;
    margin-left: -37px;
    margin-top: 20px;
    cursor: pointer;
    opacity: 0.7;
    &:hover {
      opacity: 1;
    }
  }
  .control {
    margin-top: 40px;
    height: 56px;
    .forgot {
      font-size: 16px;
      text-decoration: underline;
      color: white;
    }
  }
  .create {
    border-top: 1px solid white;
    margin-top: 35px;
    padding-top: 25px;
    font-size: 16px;
    text-align: center;
    color: $supporter-1;
    a {
      color: white;
      text-decoration: underline;
    }
  }

  .error {
    padding-top: 30px;
    color: $red-1;
    text-align: justify;
  }
  .success {
    padding-top: 30px;
    color: $green-2;
    text-align: justify;
  }
}
</style>
